import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Role } from '../../../identite/shared/classes/role';
import { IRoleByBureau, RoleByBureau } from '../../../identite/shared/classes/role-by-bureau';

@Component({
  selector: 'app-select-commerciaux',
  templateUrl: './select-commerciaux.component.html',
  styleUrls: ['./select-commerciaux.component.css']
})
export class SelectCommerciauxComponent implements OnInit {

    @Input() id: string;
    @Input() value: string;
    @Input() required: boolean;
    @Input() commerciaux: Role[];

    @Output() valueChanged: EventEmitter<string> = new EventEmitter();
    // @Output() handleValidate: EventEmitter<boolean> = new EventEmitter();

    constructor() { }

    /*onHandleValidate(value: string) {
        let isValid = true;
        if (this.required && (!value || value === '')) {
            isValid = false;
        }
        this.handleValidate.emit(isValid);
    }*/

    ngOnInit() {}

    get commerciauxDisplay(): Array<Role> | Array<IRoleByBureau> {
        if (!this.commerciaux) {
            return [];
        }

        const commerciauxByBureau = RoleByBureau.filterRoleByBureau(this.commerciaux);
        if (!commerciauxByBureau || (commerciauxByBureau instanceof Object && Object.keys(commerciauxByBureau).length === 0)) {
            return this.commerciaux;
        }

        return commerciauxByBureau;
    }

    onSelectChange(event: any) {
        this.valueChanged.emit(event.target.value);
    }

    isArrayOfRole(value: any): boolean {
        return Array.isArray(value) && value.every(item => item instanceof Role);
    }
}
